import { IntlKey } from 'locales';
import { AddonAction } from 'models/AddonAction';
import { TradeWay } from 'models/TradeWay';

export function getTradeWayIntlKey(
  tradeWay: TradeWay,
  isInternalUser: boolean,
  addonAction: AddonAction,
  isExecOnlyAddon = false,
  isConfirmTrade = false,
): IntlKey {
  const you = isInternalUser ? 'internalUser' : 'externalUser';
  const confirmTradeIntlKey = isConfirmTrade ? '.confirmTrade' : '';

  if (isExecOnlyAddon) {
    if ((tradeWay === 'Sell' && addonAction === 'Increase') || (tradeWay === 'Buy' && addonAction === 'Decrease')) {
      return `flowSense.${you}${confirmTradeIntlKey}.YouBuySgSells`;
    }
    if ((tradeWay === 'Sell' && addonAction === 'Decrease') || (tradeWay === 'Buy' && addonAction === 'Increase')) {
      return `flowSense.${you}${confirmTradeIntlKey}.YouSellSgBuys`;
    }
    return 'generic.error.message';
  }

  return tradeWay === 'Sell'
    ? `flowSense.${you}${confirmTradeIntlKey}.YouBuySgSells`
    : `flowSense.${you}${confirmTradeIntlKey}.YouSellSgBuys`;
}
